/* eslint-disable */
import { IModelResponse, IModel } from '@cian/http-api';
import { IOfferFromHistoryResponseV2Schema } from '../../entities/offer_from_history/OfferFromHistoryResponseV2Schema';
import { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetOfferFromHistoryWebRequest {
  /** Идентификатор объявления **/
  cianId: number;
  /** Категория объявления **/
  category?: ECategory;
}
export enum ECategory {
  'BedRent' = 'bedRent',
  'BuildingRent' = 'buildingRent',
  'BuildingSale' = 'buildingSale',
  'BusinessRent' = 'businessRent',
  'BusinessSale' = 'businessSale',
  'CarServiceRent' = 'carServiceRent',
  'CarServiceSale' = 'carServiceSale',
  'CommercialLandRent' = 'commercialLandRent',
  'CommercialLandSale' = 'commercialLandSale',
  'CottageRent' = 'cottageRent',
  'CottageSale' = 'cottageSale',
  'DailyBedRent' = 'dailyBedRent',
  'DailyFlatRent' = 'dailyFlatRent',
  'DailyHouseRent' = 'dailyHouseRent',
  'DailyRoomRent' = 'dailyRoomRent',
  'DomesticServicesRent' = 'domesticServicesRent',
  'DomesticServicesSale' = 'domesticServicesSale',
  'FlatRent' = 'flatRent',
  'FlatSale' = 'flatSale',
  'FlatShareSale' = 'flatShareSale',
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  'GarageRent' = 'garageRent',
  'GarageSale' = 'garageSale',
  'HouseRent' = 'houseRent',
  'HouseSale' = 'houseSale',
  'HouseShareRent' = 'houseShareRent',
  'HouseShareSale' = 'houseShareSale',
  'IndustryRent' = 'industryRent',
  'IndustrySale' = 'industrySale',
  'LandSale' = 'landSale',
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  'OfficeRent' = 'officeRent',
  'OfficeSale' = 'officeSale',
  'PublicCateringRent' = 'publicCateringRent',
  'PublicCateringSale' = 'publicCateringSale',
  'RoomRent' = 'roomRent',
  'RoomSale' = 'roomSale',
  'ShoppingAreaRent' = 'shoppingAreaRent',
  'ShoppingAreaSale' = 'shoppingAreaSale',
  'TownhouseRent' = 'townhouseRent',
  'TownhouseSale' = 'townhouseSale',
  'WarehouseRent' = 'warehouseRent',
  'WarehouseSale' = 'warehouseSale',
}
export interface IGetOfferFromHistoryWebResponse200 extends IModelResponse<IOfferFromHistoryResponseV2Schema> {
  statusCode: 200;
}
export interface IGetOfferFromHistoryWebResponse400 extends IModelResponse<IErrorResponseSchema> {
  statusCode: 400;
}
export type IGetOfferFromHistoryWebResponse = IOfferFromHistoryResponseV2Schema;

export type IGetOfferFromHistoryWebResponseError = IErrorResponseSchema;

export type TGetOfferFromHistoryWebResponse = IGetOfferFromHistoryWebResponse200 | IGetOfferFromHistoryWebResponse400;

export type TGetOfferFromHistoryWebModel = IModel<IGetOfferFromHistoryWebRequest, TGetOfferFromHistoryWebResponse>;
export interface IMappers<TResponse200, TResponse400> {
  200(response: IOfferFromHistoryResponseV2Schema): TResponse200;
  400(response: IErrorResponseSchema): TResponse400;
}
